export default "__VITE_ASSET__BJq5DHj7__"